// bx-search.js — SAFE mount into AI slot + Shopify predictive (doesn't blank the header)
(function () {
  const MOBILE_MAX = 989;
  const DESKTOP_MIN = 990;

  function isMobile() {
    return window.matchMedia(`(max-width:${MOBILE_MAX}px)`).matches;
  }
  function isDesktop() {
    return window.matchMedia(`(min-width:${DESKTOP_MIN}px)`).matches;
  }

  function getAiSlot() {
    return document.querySelector('[class*="ai-header-search-slot"]');
  }

  function getOriginalMobileSearch() {
    return (
      document.getElementById("bx-search-mobile") ||
      document.querySelector('[data-bx-search][data-bx-id="bx-search-mobile"]')
    );
  }

  // Prefer header search on desktop (prevents 2nd search fighting)
  function getDesktopSearchRoots() {
    const headerRoots = document.querySelectorAll(
      "header [data-bx-search], .shopify-section-header [data-bx-search]"
    );
    return headerRoots.length ? headerRoots : document.querySelectorAll("[data-bx-search]");
  }

  // --- visibility + mobile root detection (so we never alter desktop UI) ---
  function isElementVisible(el) {
    if (!el) return false;
    const cs = getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden") return false;
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function isMobileSearchRoot(root) {
    if (!isMobile() || !root) return false;

    // if it's hidden (common for desktop search in mobile breakpoints), ignore it
    if (!isElementVisible(root)) return false;

    if (root.id === "bx-search-mobile") return true;
    if (root.getAttribute("data-bx-id") === "bx-search-mobile") return true;

    const slot = getAiSlot();
    return !!(slot && slot.contains(root));
  }

  // --- lock spacing so the mobile bar doesn't jump on resize/orientation ---
  const __bxStableTouched = new Set();
  const __bxStableProps = ["margin-top", "margin-bottom", "padding-top", "padding-bottom"];

  function lockStableSpacing(el) {
    if (!el) return;
    const cs = getComputedStyle(el);

    if (!el.__bxLockedSpacing) {
      el.__bxLockedSpacing = {
        marginTop: cs.marginTop,
        marginBottom: cs.marginBottom,
        paddingTop: cs.paddingTop,
        paddingBottom: cs.paddingBottom,
      };
    }

    const s = el.__bxLockedSpacing;
    el.style.setProperty("margin-top", s.marginTop, "important");
    el.style.setProperty("margin-bottom", s.marginBottom, "important");
    el.style.setProperty("padding-top", s.paddingTop, "important");
    el.style.setProperty("padding-bottom", s.paddingBottom, "important");

    __bxStableTouched.add(el);
  }

  function unlockStableSpacing(el) {
    if (!el || !el.style) return;
    __bxStableProps.forEach((p) => el.style.removeProperty(p));
  }

  function unlockAllStableSpacing() {
    __bxStableTouched.forEach((el) => unlockStableSpacing(el));
    __bxStableTouched.clear();
  }

  // Re-apply stable spacing for the *mobile* mounted search so it doesn't jump on resize
  function stabilizeMobileSearchBar(root) {
    if (!isMobileSearchRoot(root)) return;

    const targets = [];
    const slot = getAiSlot();

    if (slot) {
      targets.push(slot);
      if (slot.parentElement) targets.push(slot.parentElement);
      if (slot.parentElement && slot.parentElement.parentElement) targets.push(slot.parentElement.parentElement);
    }

    targets.push(root);

    const form = root.querySelector("form");
    if (form) targets.push(form);

    [...new Set(targets)].forEach(lockStableSpacing);
  }

  // --- Predictive endpoint ---
  const endpoint = (q) =>
    `/search/suggest.json?q=${encodeURIComponent(q)}` +
    `&resources[type]=product` +
    `&resources[limit]=8` +
    `&resources[options][unavailable_products]=show`;

  function debounce(fn, wait = 180) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  }

  // --- Portal dropdown ---
  const portal = document.createElement("div");
  portal.className = "bx-dropdown-portal";
  Object.assign(portal.style, {
    display: "none",
    position: "fixed",
    zIndex: "2147483647",
    maxHeight: "60vh",
    overflowY: "auto",
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 10px 30px rgba(0,0,0,.12)",
    border: "1px solid rgba(0,0,0,.06)",
  });
  document.body.appendChild(portal);

  let activeRoot = null;
  let activeInput = null;

  // NEW: keep dropdown open through keyboard-hide resize (Android)
  let keepPortalOpenOnResize = false;

  function portalIsOpen() {
    return portal.style.display === "block";
  }

  function setActive(root, input) {
    activeRoot = root;
    activeInput = input;
  }

  function positionPortal(inputEl) {
    if (!inputEl) return;
    const r = inputEl.getBoundingClientRect();
    const width = r.width;
    const left = Math.max(8, Math.min(r.left, window.innerWidth - width - 8));
    portal.style.left = `${left}px`;
    portal.style.top = `${r.bottom + 8}px`;
    portal.style.width = `${width}px`;
  }

  let didBlurForPortal = false;
  let touchStartY = 0;

  function maybeHideKeyboardOnPortalScroll() {
    if (!isMobile()) return;
    if (didBlurForPortal) return;
    if (!activeInput) return;
    if (document.activeElement !== activeInput) return;

    // We are about to blur to hide keyboard; keep portal open through resize.
    keepPortalOpenOnResize = true;

    didBlurForPortal = true;
    activeInput.blur();
  }

  function closePortal() {
    portal.style.display = "none";
    portal.innerHTML = "";
    didBlurForPortal = false;
    keepPortalOpenOnResize = false;
  }

  function renderPortal(products, q) {
    if (!q || q.length < 2) return closePortal();

    didBlurForPortal = false;
    keepPortalOpenOnResize = false;

    if (!products || !products.length) {
      portal.innerHTML = `
        <a class="bx-ps-item" href="/search?type=product&q=${encodeURIComponent(q)}">
          <div class="bx-ps-img" aria-hidden="true"></div>
          <span>Търси за “${q}”</span>
        </a>
        <div class="bx-ps-empty">Няма резултати</div>
      `;
      portal.style.display = "block";
      return;
    }

    portal.innerHTML = products
      .slice(0, 8)
      .map((p) => {
        const rawImg = p.featured_image?.url || "";
        const img = rawImg
          ? rawImg.includes("?")
            ? `${rawImg}&width=80`
            : `${rawImg}?width=80`
          : "";
        const title = p.title || "";
        const url = p.url || "#";
        return `
          <a class="bx-ps-item" href="${url}">
            ${
              img
                ? `<img src="${img}" alt="" width="40" height="40" loading="lazy">`
                : `<div class="bx-ps-img" aria-hidden="true"></div>`
            }
            <span>${title}</span>
          </a>
        `;
      })
      .join("");

    portal.style.display = "block";
  }

  // Prevent blur before click
  portal.addEventListener("mousedown", (e) => e.preventDefault());

  // Mobile: when user starts scrolling the suggestions, hide keyboard BUT keep dropdown open
  portal.addEventListener(
    "touchstart",
    (e) => {
      touchStartY = e.touches?.[0]?.clientY ?? 0;
    },
    { passive: true }
  );

  portal.addEventListener(
    "touchmove",
    (e) => {
      const y = e.touches?.[0]?.clientY ?? 0;
      if (Math.abs(y - touchStartY) > 6) maybeHideKeyboardOnPortalScroll();
    },
    { passive: true }
  );

  portal.addEventListener(
    "scroll",
    () => {
      maybeHideKeyboardOnPortalScroll();
    },
    { passive: true }
  );

  // Desktop: scroll inside portal, not page
  portal.addEventListener(
    "wheel",
    (e) => {
      if (!isDesktop() || !portalIsOpen()) return;
      e.preventDefault();
      e.stopPropagation();
      portal.scrollTop += e.deltaY;
    },
    { passive: false }
  );

  // --- Global listeners ONCE ---
  let globalsBound = false;
  function bindGlobalsOnce() {
    if (globalsBound) return;
    globalsBound = true;

    window.addEventListener(
      "scroll",
      () => {
        if (portalIsOpen() && activeInput) positionPortal(activeInput);
      },
      true
    );

    const relayout = () => {
      // If we left mobile -> desktop, remove our mobile spacing locks so desktop isn't affected
      if (!isMobile()) {
        unlockAllStableSpacing();
      }

      layoutAllSearchUIs();
      if (portalIsOpen() && activeInput) positionPortal(activeInput);

      // IMPORTANT:
      // On Android, keyboard hide triggers resize; if we blurred because user scrolled portal,
      // DO NOT close the portal. Otherwise close as usual.
      if (isMobile() && !(portalIsOpen() && keepPortalOpenOnResize)) {
        closePortal();
      }

      // Theme header often updates spacing after resize/orientation; do late stabilization (mobile-only)
      if (isMobile()) {
        const slot = getAiSlot();
        const root =
          slot?.querySelector("[data-bx-search], #bx-search-mobile") ||
          document.querySelector("#bx-search-mobile,[data-bx-search][data-bx-id='bx-search-mobile']");

        if (root) {
          stabilizeMobileSearchBar(root);
          requestAnimationFrame(() => stabilizeMobileSearchBar(root));
          setTimeout(() => stabilizeMobileSearchBar(root), 80);
          setTimeout(() => stabilizeMobileSearchBar(root), 220);
        }

        // After resize settles, allow normal closing again
        setTimeout(() => {
          keepPortalOpenOnResize = false;
        }, 260);
      }
    };

    window.addEventListener("resize", relayout);
    window.addEventListener("orientationchange", relayout);

    document.addEventListener(
      "pointerdown",
      (e) => {
        if (!portalIsOpen()) return;
        if (portal.contains(e.target)) return;
        if (activeRoot && activeRoot.contains(e.target)) return;
        closePortal();
      },
      { passive: true }
    );
  }

  // --- Predictive binder for ONE search root node ---
  function initPredictive(root) {
    if (!root || root.__bxPredictiveInit) return;
    root.__bxPredictiveInit = true;

    const input = root.querySelector('input[type="search"].bx-search__input');
    const resetBtn = root.querySelector(".bx-search__reset");
    const form = root.querySelector("form");
    if (!input || !form) return;

    bindGlobalsOnce();

    let aborter = null;

    const fetchSuggest = debounce(async () => {
      const q = (input.value || "").trim();
      if (q.length < 2) return closePortal();

      setActive(root, input);

      if (aborter) aborter.abort();
      aborter = new AbortController();

      try {
        const res = await fetch(endpoint(q), {
          signal: aborter.signal,
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        });
        if (!res.ok) throw new Error("bad response");

        const data = await res.json();
        const products = data?.resources?.results?.products || [];
        positionPortal(input);
        renderPortal(products, q);
      } catch (e) {
        if (e.name !== "AbortError") closePortal();
      }
    }, 180);

    input.addEventListener("input", fetchSuggest);
    input.addEventListener("focus", () => {
      // user re-focused; allow normal portal behavior again
      keepPortalOpenOnResize = false;
      didBlurForPortal = false;

      layoutActionsForRoot(root);
      fetchSuggest();
    });

    if (resetBtn) {
      resetBtn.addEventListener("click", () => {
        input.value = "";
        input.focus();
        closePortal();
      });
    }

    form.addEventListener("submit", () => closePortal());
  }

  // --- Icons (SVG) ---
  function applyClearIcon(resetBtn, px = 26, nudgeY = 0) {
    resetBtn.textContent = "";
    resetBtn.innerHTML = `
      <svg width="${px}" height="${px}" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <line x1="6" y1="6" x2="18" y2="18" stroke="#ff6a00" stroke-width="2.8" stroke-linecap="round"/>
        <line x1="18" y1="6" x2="6" y2="18" stroke="#ff6a00" stroke-width="2.8" stroke-linecap="round"/>
      </svg>
    `;

    resetBtn.style.setProperty("display", "grid", "important");
    resetBtn.style.setProperty("place-items", "center", "important");
    resetBtn.style.setProperty("padding", "0", "important");
    resetBtn.style.setProperty("line-height", "0", "important");
    resetBtn.style.setProperty("background", "transparent", "important");
    resetBtn.style.setProperty("border-radius", "999px", "important");
    resetBtn.style.setProperty("margin", "0", "important");

    // Normalize iOS/Android button rendering
    resetBtn.style.setProperty("-webkit-appearance", "none", "important");
    resetBtn.style.setProperty("appearance", "none", "important");

    const svg = resetBtn.querySelector("svg");
    if (svg) {
      svg.style.display = "block";
      svg.style.margin = "0";
      svg.style.transform = `translateY(${nudgeY}px)`;
    }
  }

  function applyMagnifierIcon(submitBtn, px = 26, nudgeY = -1) {
    submitBtn.textContent = "";
    submitBtn.innerHTML = `
      <svg width="${px}" height="${px}" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <circle cx="11" cy="12" r="6" fill="none" stroke="#ff6a00" stroke-width="2.6"/>
        <line x1="16" y1="17" x2="21" y2="22" stroke="#ff6a00" stroke-width="2.6" stroke-linecap="round"/>
      </svg>
    `;

    submitBtn.style.setProperty("display", "grid", "important");
    submitBtn.style.setProperty("place-items", "center", "important");
    submitBtn.style.setProperty("padding", "0", "important");
    submitBtn.style.setProperty("line-height", "0", "important");
    submitBtn.style.setProperty("background", "transparent", "important");
    submitBtn.style.setProperty("border-radius", "999px", "important");
    submitBtn.style.setProperty("margin", "0", "important");

    // Normalize iOS/Android button rendering
    submitBtn.style.setProperty("-webkit-appearance", "none", "important");
    submitBtn.style.setProperty("appearance", "none", "important");

    const svg = submitBtn.querySelector("svg");
    if (svg) {
      svg.style.display = "block";
      svg.style.margin = "0";
      svg.style.transform = `translateY(${nudgeY}px)`;
    }
  }

  // --- Actions UI layout ---
  function layoutActionsForRoot(root) {
    // IMPORTANT: only style the MOBILE search UI
    if (!isMobileSearchRoot(root)) return;

    const form = root?.querySelector("form");
    const input = form?.querySelector('input[type="search"].bx-search__input');
    if (!form || !input) return;

    const actions = form.querySelector(".bx-search__actions");
    if (!actions) return;

    // keep the whole mobile search row stable (prevents "jump up" on breakpoint reflow)
    stabilizeMobileSearchBar(root);

    form.classList.add("bx-mobile-ready");
    form.style.setProperty("position", "relative", "important");

    // Anchor actions exactly to the INPUT box
    const formRect = form.getBoundingClientRect();
    const inputRect = input.getBoundingClientRect();

    const topOffset = inputRect.top - formRect.top;
    const inputH = inputRect.height;
    if (!inputH) return;

    actions.style.setProperty("position", "absolute", "important");
    actions.style.setProperty("right", "12px", "important");
    actions.style.setProperty("top", `${topOffset}px`, "important");
    actions.style.setProperty("height", `${inputH}px`, "important");
    actions.style.setProperty("bottom", "auto", "important");
    actions.style.setProperty("transform", "none", "important");
    actions.style.setProperty("display", "flex", "important");
    actions.style.setProperty("align-items", "center", "important");
    actions.style.setProperty("gap", "12px", "important");
    actions.style.setProperty("z-index", "5", "important");
    actions.style.setProperty("padding", "0", "important");
    actions.style.setProperty("margin", "0", "important");

    const btnSize = Math.max(32, Math.min(40, Math.round(inputH - 6)));

    // Bigger X on phones
    const clearPx = Math.max(24, Math.min(30, Math.round(btnSize * 0.80)));
    const iconPx = Math.max(24, Math.min(28, Math.round(btnSize * 0.78)));

    const resetBtn = actions.querySelector(".bx-search__reset");
    const submitBtn = actions.querySelector(".bx-search__submit");
    const divider = actions.querySelector(".bx-search__divider");

    if (resetBtn) {
      resetBtn.style.setProperty("width", `${btnSize}px`, "important");
      resetBtn.style.setProperty("height", `${btnSize}px`, "important");
      resetBtn.style.setProperty("border", "0", "important");
      resetBtn.style.setProperty("background", "transparent", "important");
      resetBtn.style.setProperty("margin", "0", "important");
      resetBtn.style.setProperty("padding", "0", "important");
      resetBtn.style.setProperty("align-self", "center", "important");
      resetBtn.style.setProperty("display", "grid", "important");
      resetBtn.style.setProperty("place-items", "center", "important");
      resetBtn.style.setProperty("line-height", "0", "important");

      applyClearIcon(resetBtn, clearPx, -1);
    }

    if (submitBtn) {
      submitBtn.style.setProperty("width", `${btnSize}px`, "important");
      submitBtn.style.setProperty("height", `${btnSize}px`, "important");
      submitBtn.style.setProperty("border", "0", "important");
      submitBtn.style.setProperty("background", "transparent", "important");
      submitBtn.style.setProperty("margin", "0", "important");
      submitBtn.style.setProperty("padding", "0", "important");
      submitBtn.style.setProperty("align-self", "center", "important");
      applyMagnifierIcon(submitBtn, iconPx, -3);
    }

    if (divider) {
      divider.style.setProperty("display", "inline-block", "important");
      divider.style.setProperty("width", "1px", "important");
      divider.style.setProperty("height", `${Math.round(btnSize * 0.55)}px`, "important");
      divider.style.setProperty("background", "rgba(255,106,0,.55)", "important");
      divider.style.setProperty("align-self", "center", "important");
      divider.style.setProperty("margin", "0", "important");
    }

    // Ensure input has enough right padding so buttons never overlap
    requestAnimationFrame(() => {
      const actionsW = Math.ceil(actions.getBoundingClientRect().width || 0);
      const pad = Math.max(72, actionsW + 18);
      input.style.setProperty("padding-right", `${pad}px`, "important");
    });
  }

  function ensureActionsUI(root) {
    // IMPORTANT: only inject actions UI for the MOBILE search
    if (!isMobileSearchRoot(root)) return;

    if (!root || root.__bxActionsInit) return;
    root.__bxActionsInit = true;

    const form = root.querySelector("form");
    if (!form) return;

    // Actions container
    let actions = form.querySelector(".bx-search__actions");
    if (!actions) {
      actions = document.createElement("div");
      actions.className = "bx-search__actions";
      form.appendChild(actions);
    }

    // Reset
    let resetBtn = actions.querySelector(".bx-search__reset");
    if (!resetBtn) {
      resetBtn = document.createElement("button");
      resetBtn.className = "bx-search__reset";
      resetBtn.type = "button";
      resetBtn.setAttribute("aria-label", "Clear");
      actions.appendChild(resetBtn);
    }

    // Divider
    let divider = actions.querySelector(".bx-search__divider");
    if (!divider) {
      divider = document.createElement("span");
      divider.className = "bx-search__divider";
      divider.setAttribute("aria-hidden", "true");
      actions.appendChild(divider);
    }

    // Submit
    let submitBtn = actions.querySelector(".bx-search__submit");
    if (!submitBtn) {
      submitBtn = document.createElement("button");
      submitBtn.className = "bx-search__submit";
      submitBtn.type = "submit";
      submitBtn.setAttribute("aria-label", "Search");
      actions.appendChild(submitBtn);
    }

    // Wire reset
    const input = form.querySelector('input[type="search"]');
    resetBtn.addEventListener("click", () => {
      if (!input) return;
      input.value = "";
      input.focus();
      input.dispatchEvent(new Event("input", { bubbles: true }));
      closePortal();
    });

    // Layout now + after a tick (helps with responsive header reflow)
    layoutActionsForRoot(root);
    setTimeout(() => layoutActionsForRoot(root), 0);
    requestAnimationFrame(() => layoutActionsForRoot(root));
  }

  function forceMobileSubmitOnTop(root) {
    if (!root || root.__bxMobileFixInit) return;
    root.__bxMobileFixInit = true;

    const form = root.querySelector("form");
    if (!form) return;
    form.classList.add("bx-mobile-ready");
  }

  function mountIntoAiSlot() {
    if (!isMobile()) return;

    const slot = getAiSlot();
    if (!slot) return;

    // lock slot spacing (mobile-only)
    lockStableSpacing(slot);

    const existing = slot.querySelector("[data-bx-search], #bx-search-mobile");
    if (existing) {
      ensureActionsUI(existing);
      forceMobileSubmitOnTop(existing);
      initPredictive(existing);

      // lock spacing now + after theme reflow
      stabilizeMobileSearchBar(existing);
      requestAnimationFrame(() => stabilizeMobileSearchBar(existing));
      setTimeout(() => stabilizeMobileSearchBar(existing), 120);
      setTimeout(() => stabilizeMobileSearchBar(existing), 260);

      return;
    }

    const original = getOriginalMobileSearch();
    if (!original) return;

    const clone = original.cloneNode(true);
    clone.style.display = "block";

    slot.replaceChildren(clone);

    ensureActionsUI(clone);
    forceMobileSubmitOnTop(clone);
    initPredictive(clone);

    // IMPORTANT: stabilize clone too
    stabilizeMobileSearchBar(clone);
    requestAnimationFrame(() => stabilizeMobileSearchBar(clone));
    setTimeout(() => stabilizeMobileSearchBar(clone), 120);
    setTimeout(() => stabilizeMobileSearchBar(clone), 260);
  }

  function layoutAllSearchUIs() {
    document.querySelectorAll("[data-bx-search]").forEach((root) => {
      if (root.__bxActionsInit) layoutActionsForRoot(root);
    });
  }

  // Debounce init to avoid thrashing during resize / header mutations
  let initQueued = false;
  function scheduleInitAll() {
    if (initQueued) return;
    initQueued = true;

    // if we left mobile, clean up our mobile-only spacing locks
    if (!isMobile()) unlockAllStableSpacing();

    requestAnimationFrame(() => {
      initQueued = false;
      initAll();
    });
  }

  function initAll() {
    // Desktop: predictive only (DO NOT change desktop UI)
    getDesktopSearchRoots().forEach((root) => {
      initPredictive(root);
    });

    // Mobile mount + UI + predictive
    mountIntoAiSlot();

    // Layout after any init (mobile-only)
    layoutAllSearchUIs();
  }

  document.addEventListener("DOMContentLoaded", scheduleInitAll);
  window.addEventListener("resize", scheduleInitAll);
  window.addEventListener("orientationchange", scheduleInitAll);

  new MutationObserver(scheduleInitAll).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
